import { createEngine } from '../shared/engine';
import { Settings, T } from './state';

/** The one engine instance for the browser, reading the live cache. Call Engine.reset() after data changes (render does). */
export const Engine = createEngine({ rows: n => T(n), setting: k => Settings.get(k) });
